import { render, staticRenderFns } from "./PicTableCard.vue?vue&type=template&id=7cb9f3d8&scoped=true&"
import script from "./PicTableCard.vue?vue&type=script&lang=js&"
export * from "./PicTableCard.vue?vue&type=script&lang=js&"
import style0 from "./PicTableCard.vue?vue&type=style&index=0&id=7cb9f3d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb9f3d8",
  null
  
)

export default component.exports